import { connect } from 'react-redux';
import {
  DividendNextSteps,
  DividendNextStepsProps,
} from '@/pages/CompanyReport/components/Dividend';
import { getSummary } from '@/pages/CompanyReport/redux/selectors';

const mapStateToProps = (state, ownProps): Partial<DividendNextStepsProps> => {
  const summary = getSummary(state, ownProps);
  return {
    countryISO: summary.countryISO,
    industryPrimaryName: summary.industryData.primaryName,
  };
};

export default connect(mapStateToProps)(DividendNextSteps);
